import { QueryParams } from "./../models/http/QueryParams";
import { DefaultPageParams, DefaultSortParams, PageParams, SortParams } from "../models";
import { RequestConfig, RequestOptions } from "../api";

export const getRequestOptions = (
    url: string,
    config?: RequestConfig,
    queryParams?: QueryParams,
    sortParams: SortParams = DefaultSortParams,
    pageParams: PageParams = DefaultPageParams,
    includeInactive: boolean = false,
    suppressPaging: boolean = false
): RequestOptions => {
    const params = new URLSearchParams();

    if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
            if (queryParams[key]) {
                params.append(key, value);
            }
        });
    }

    if (config?.params) {
        Object.entries(config.params).forEach(([key, value]) => {
            params.append(key, value);
        });
    }

    if (suppressPaging) {
        params.append("all", "true");
    } else {
        params.append("page", `${pageParams.page}`);
        params.append("pageSize", `${pageParams.pageSize}`);
    }

    if (sortParams.orderBy) {
        params.append("orderBy", sortParams.orderBy);
    }
    if (sortParams.orderDesc) {
        params.append("orderDesc", sortParams.orderDesc);
    }

    if (includeInactive) {
        params.append("includeInactive", "true");
    }

    const requestOptions: RequestOptions = {
        url,
        config: {
            ...config,
            params,
        },
    };

    return requestOptions;
};
